"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getVersionIdOfContent_1 = tslib_1.__importDefault(require("./getVersionIdOfContent"));
const getRootContentId = (content) => content.rootOfferId || content._id;
function setVersionIdOfState(command, content, state) {
    if (!state) {
        return;
    }
    const { timeStamp } = command;
    const previousVersionId = state.versionId;
    const rootContentId = getRootContentId(content);
    const versionId = getVersionIdOfContent_1.default(command.versions, rootContentId);
    if (versionId || previousVersionId) {
        state.versionId = versionId || previousVersionId;
        if (state.versionId !== previousVersionId) {
            state.updatedAt = timeStamp;
        }
    }
}
exports.default = setVersionIdOfState;
//# sourceMappingURL=setVersionIdOfState.js.map